/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from 'react';
import { Segment } from 'semantic-ui-react';
import { TAB_DOCTOR, TAB_PATIENT } from 'Constants/webchat';
import NotesForProvider from 'Containers/Teleconsult/Main/Messages/NotesForProvider/NotesForProvider';
import { CONSULT_ACCEPTED, CONSULT_TYPE_FOLLOW_UP } from 'Constants/consults';
import useMcHistory from 'Hooks/useMcHistory';
import useAuth from 'Hooks/useAuth';
import { findClinicIdFromClinicsMapping } from 'Helpers/consult-utils';
import useGetRecentReason from 'Hooks/patient/useGetRecentReason';

import MessageBodyDoctor from './MessageBodyDoctor';
import MessageBodyPatient from './MessageBodyPatient';
import styles from './MessageBodyWrapper.less';

const MessageBodyWrapper = props => {
  const {
    conversationActive,
    openMedicalCertificate,
    conversationActiveId,
    activeTab,
    onChangeTab,
    doctor,
    isMinimize,
    onSetReply,
    pendingConsultActive,
    // changeContextMenu,
  } = props;
  const { doctors, consultType } = conversationActive?.latestConsult || {
    doctors: [],
    consultType: null,
  };

  const { accountId } = useAuth();
  const { getCountHistoryMc } = useMcHistory();
  const { requestReasons, getRecentReasons, resetRecentReason } = useGetRecentReason();

  // use local state to store the number of MCs because if use redux state, it will be error when
  // slow network show wrong number of MCs of other consult
  const [numberOfMC, setNumberOfMc] = useState(-1); // NOSONAR

  // common condition for show notes for provider
  const showNotesForProvider =
    conversationActive &&
    conversationActive?.latestConsult?.status === CONSULT_ACCEPTED &&
    !isMinimize &&
    consultType !== CONSULT_TYPE_FOLLOW_UP;

  useEffect(() => {
    const forPatientId = conversationActive?.latestConsult?.forPatient?.id;
    const clinicId = findClinicIdFromClinicsMapping(
      conversationActive?.latestConsult?.clinics || [],
      +accountId,
    );

    const fetchMcCount = async () => {
      const serviceId = conversationActive?.latestConsult?.service?.id;

      const data = await getCountHistoryMc(forPatientId, clinicId, serviceId);
      setNumberOfMc(data?.data?.total ?? 0);
    };

    if (showNotesForProvider) {
      fetchMcCount();
      getRecentReasons(forPatientId, clinicId);
    }

    return () => {
      setNumberOfMc(0);
      resetRecentReason();
    };
  }, [
    conversationActive?.id,
    conversationActive?.latestConsult?.id,
    conversationActive?.latestConsult?.status,
  ]);

  // only show patient chat if there is only 1 doctor (me) or pending consult is active
  if (doctors?.length === 1 || pendingConsultActive !== -1) {
    return (
      <Segment
        style={{
          padding: 0,
          overflow: 'hidden',
          flex: 1,
          border: 'none',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}>
        {showNotesForProvider && (
          <NotesForProvider
            mcCount={numberOfMC}
            lastConsultReasons={requestReasons}
            conversationActiveId={conversationActiveId}
          />
        )}
        <div className={styles.content} id="message-body">
          <MessageBodyPatient
            openMedicalCertificate={openMedicalCertificate}
            conversationActiveId={conversationActiveId}
            conversationActive={conversationActive}
            doctor={doctor}
            isMinimize={isMinimize}
            onSetReply={onSetReply}
            pendingConsultActive={pendingConsultActive}
          />
        </div>
      </Segment>
    );
  }

  const classTabActive = `${styles.tabItem} ${styles.tabItemActive}`;
  const classTabItem = styles.tabItem;
  const isActivePatientChat = activeTab === TAB_PATIENT;

  return (
    <Segment
      style={{ padding: 0 }}
      className={isMinimize ? styles.containerMinimize : styles.container}>
      <div className={styles.tab}>
        <div
          className={isActivePatientChat ? classTabActive : classTabItem}
          onClick={activeTab === TAB_PATIENT ? () => {} : onChangeTab}>
          Patient Chat
        </div>
        <div
          className={!isActivePatientChat ? classTabActive : classTabItem}
          onClick={activeTab === TAB_DOCTOR ? () => {} : onChangeTab}>
          Doctor Chat
        </div>
      </div>
      {showNotesForProvider && isActivePatientChat && (
        <NotesForProvider
          mcCount={numberOfMC}
          lastConsultReasons={requestReasons}
          conversationActiveId={conversationActiveId}
        />
      )}
      <div className={styles.content} id="message-body">
        <div style={{ display: isActivePatientChat ? 'block' : 'none', height: '100%' }}>
          <MessageBodyPatient
            openMedicalCertificate={openMedicalCertificate}
            conversationActiveId={conversationActiveId}
            conversationActive={conversationActive}
            active={activeTab === TAB_PATIENT}
            doctor={doctor}
            isMinimize={isMinimize}
            pendingConsultActive={pendingConsultActive}
            onSetReply={onSetReply}
          />
        </div>
        <div style={{ display: !isActivePatientChat ? 'block' : 'none', height: '100%' }}>
          <MessageBodyDoctor
            conversationActiveId={conversationActiveId}
            conversationActive={conversationActive}
            active={activeTab === TAB_DOCTOR}
            doctor={doctor}
            isMinimize={isMinimize}
            onSetReply={onSetReply}
          />
        </div>
      </div>
    </Segment>
  );
};

export default memo(MessageBodyWrapper);
